import {
  CreatePurchaseRequestItemV2Payload,
  Currency,
  PurchaseRequestItemType,
} from "../../../types";

/**
 * One line of the request being composed. Extends the API payload with a few
 * display-only fields (material name/EAN/owner) so the compact row can render
 * without re-fetching, plus a stable client id used as the React key and as the
 * accordion's expanded-row identity.
 */
export type ItemRow = CreatePurchaseRequestItemV2Payload & {
  materialEan?: string;
  materialName?: string;
  materialOwnerName?: string;
  /** Client-side stable id. Never sent to the API. */
  clientId?: string;
};

export const generateClientId = () =>
  `c-${Date.now()}-${Math.random().toString(36).slice(2, 8)}`;

export const buildEmptyItem = (): ItemRow => ({
  title: "",
  description: "",
  quantity: null,
  measurementUnit: "",
  budgetValue: null,
  currency: Currency.USD,
  budgetCurrency: Currency.USD,
  itemType: PurchaseRequestItemType.GOOD,
  costCenter: "",
  neededFrom: null,
  neededTo: null,
  aiValidated: false,
  source: "MANUAL",
  clientId: generateClientId(),
});
